import React from 'react';
import { withFormsy } from 'formsy-react';
import { AddressDto, CompanySearchDto } from 'models/dtoTypes';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CompanyGenericSearchDialog from 'kosmos/components/CompanyGenericSearchDialog';

interface IProps {
  setValue?: (companyId: string) => void;
  onChange?: (companyId: string) => void;
}

function CompanyPickerWiget(props: IProps) {
  const [selectedCompany, setSelectedCompany] = React.useState<CompanySearchDto>();
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation('default');
  const { setValue, onChange } = props;

  function handleSelectCompany(company?: CompanySearchDto) {
    const companyId = company?.tradesunAIId || '';
    setSelectedCompany(company);
    if (setValue) {
      setValue(companyId);
    }
    if (onChange) {
      onChange(companyId);
    }
    setOpen(false);
  }

  const generateFullAddress = (address?: AddressDto) => {
    if (!address) {
      return 'Unknown';
    }
    const { addressLine1, addressLine2, city, country, postalCode } = address;
    const AddrComponents = [addressLine1, addressLine2, city, country, postalCode];
    return AddrComponents.filter((c) => c).join(', ');
  };

  const generateFullIdentifier = () => {
    if (!selectedCompany?.registrationNumbers) {
      return 'Unknown';
    }
    const identifiers = (selectedCompany?.registrationNumbers || []).map((r) => r.identifier || '');
    return identifiers.filter((c) => c).join(', ');
  };

  const renderContent = () => {
    return (
      <div style={{ marginTop: 15 }}>
        <Typography variant="body1" gutterBottom>
          {t('company-name')}: {selectedCompany?.name}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {t('address')}: {generateFullAddress(selectedCompany?.address)}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {t('identifier')}: {generateFullIdentifier()}
        </Typography>
      </div>
    );
  };

  return (
    <div>
      <Button disabled={open} variant="contained" color="primary" onClick={() => setOpen(true)}>
        {t('search-company')}
      </Button>
      {selectedCompany && renderContent()}
      <CompanyGenericSearchDialog
        open={open}
        onClose={() => setOpen(false)}
        onSelectCompany={handleSelectCompany}
      />
    </div>
  );
}

const CompanyPicker = React.memo(withFormsy(CompanyPickerWiget));

export default CompanyPicker;
